import React, { memo } from 'react';
import {
  IconHome,
  IconProfile,
  IconStore,
  IconTheme,
  IconLink,
  IconGallery,
  IconResume,
  IconBasket,
  IconStats,
} from '@redlink/components/atoms';

export const DrawerIcon = memo(({ name, color, size, focused }) => {
  switch (name) {
    case 'home':
      return <IconHome {...{ color, size }} />;
    case 'profile':
      return <IconProfile {...{ color, size }} />;
    case 'shop':
      return <IconStore {...{ color, size }} />;
    case 'theme':
      return <IconTheme {...{ color, size }} />;
    case 'links':
      return <IconLink {...{ color, size }} />;
    case 'gallery':
      return <IconGallery {...{ color, size }} />;
    case 'resume':
      return <IconResume {...{ color, size }} />;
    case 'order':
      return <IconBasket {...{ color, size }} />;
    case 'report':
      return <IconStats {...{ color, size }} />;
    default:
      return <IconProfile {...{ color, size }} />;
  }
});
